{
  "Dashboard": "Дашборд",
  "BlyCareShippingProte": "BlyCare Захист доставки",
  "LoadingBlyCare": "Завантаження BlyCare…",
  "LoadingWidgetSetting": "Завантаження налаштувань віджета…",
  "PreparingYourWorkspa": "Підготовка робочого простору",
  "Language": "Мова",
  "English": "English",
  "EnglishDefault": "English (за замовчуванням)",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "Посібник із налаштування",
  "CompletedOfTotalComp": "{{completed}} з {{total}} виконано",
  "Dismiss": "Закрити",
  "MoreActions": "Більше дій",
  "ToggleSetupGuide": "Перемкнути посібник із налаштування",
  "ActivateAppEmbed": "Активувати вбудовування застосунку",
  "ClickTheEnableButton": "1. Натисніть кнопку «Увімкнути» нижче, щоб відкрити редактор теми Shopify.",
  "BlyCareEmbedSection": "2. Знайдіть BlyCare у розділі «Вбудовування застосунків» ліворуч. Переконайтеся, що перемикач увімкнено. Потім натисніть «Зберегти» у верхньому правому куті.",
  "Enable": "Увімкнути",
  "PublishWidget": "Опублікувати віджет",
  "PublishStorefront": "Опублікуйте віджет у своєму магазині, щоб клієнти могли його придбати.",
  "Publish": "Опублікувати",
  "SetProtectionFee": "Установити плату за захист",
  "FeeYouWantToCharge": "Установіть плату, яку ви хочете стягувати з клієнтів.",
  "Setup": "Налаштувати",
  "TestYourWidgetOnYour": "Перевірте віджет у своєму магазині",
  "AddAProductToYourCar": "Додайте товар до кошика та переконайтеся, що віджет захисту доставки з’явився. Виберіть захист доставки, перейдіть до оформлення замовлення та переконайтеся, що товар із захистом доставки включено на сторінку оформлення.",
  "TestNow": "Перевірити зараз",
  "Working": "Усе працює",
  "NeedHelp": "Потрібна допомога",
  "MarkAsCompleted": "Позначити як виконане",
  "AppStatus": "Статус застосунку",
  "AppEmbed": "Вбудовування застосунку",
  "EnableAppEmbedToDisp": "Увімкніть вбудовування застосунку, щоб показувати захист доставки в кошику.",
  "CartPage": "Показувати захист доставки на сторінці кошика.",
  "CheckoutBlock": "Блок оформлення замовлення",
  "CheckoutPage": "Показувати захист доставки на сторінці оформлення замовлення.",
  "Active": "Активний",
  "Inactive": "Неактивний",
  "Analytics": "Аналітика",
  "Today": "Сьогодні",
  "Last7Days": "Останні 7 днів",
  "Last30Days": "Останні 30 днів",
  "Last60Days": "Останні 60 днів",
  "Last90Days": "Останні 90 днів",
  "Last365Days": "Останні 365 днів",
  "Custom": "Власний",
  "Start": "Початок",
  "End": "Кінець",
  "DateRange": "Діапазон дат",
  "SelectedRange": "Вибраний діапазон: {{range}}",
  "Cancel": "Скасувати",
  "Save": "Зберегти",
  "ChooseAStartDateOnOr": "Виберіть дату початку не пізніше дати завершення та не вибирайте день після сьогоднішнього.",
  "PreviousMonth": "Попередній місяць",
  "NextMonth": "Наступний місяць",
  "ProtectionRevenue": "Дохід від захисту",
  "ProtectedOrders": "Захищені замовлення",
  "ProtectedOrderRate": "Відсоток захищених замовлень",
  "LoadingAnalytics": "Завантаження аналітики…",
  "AnalyticsCouldNotLo": "Не вдалося завантажити аналітику",
  "RetryAnalytics": "Повторити завантаження аналітики",
  "Resources": "Ресурси",
  "HowDoesShippingProte": "Як працює захист доставки?",
  "BlyCareAddsAShipping": "BlyCare додає віджет захисту доставки до вашого кошика. Клієнти можуть додати захист для своїх замовлень. Продавець стягує плату за захист, визначає, які випадки покриваються, і використовує ці кошти для врегулювання претензій.",
  "DoesBlyCareCoverInsu": "Чи покриває BlyCare страхові претензії?",
  "NoBlyCareIsNotInsura": "Ні. BlyCare не є страхуванням і не виплачує за претензіями. BlyCare лише надає віджет і інструменти, за допомогою яких продавці керують власною програмою захисту доставки.",
  "EmailUs": "Написати нам",
  "LiveChat": "Онлайн-чат",
  "HelpCenter": "Довідковий центр",
  "Settings": "Налаштування",
  "CheckoutWidget": "Віджет оформлення замовлення",
  "CartWidget": "Віджет кошика",
  "PriceSetting": "Налаштування ціни",
  "ProductSetting": "Налаштування товару",
  "AdminLanguage": "Мова адміністратора",
  "AdminLanguageTitle": "Мова адміністратора",
  "AdminLanguageHelp": "Змінює мову застосунку лише для вас. На клієнтів це не впливає.",
  "AppLanguage": "Мова застосунку",
  "UnableToLoadSettings": "Не вдалося завантажити налаштування",
  "TryAgain": "Спробувати ще раз",
  "Discard": "Відхилити",
  "LoadingSettings": "Завантаження налаштувань",
  "PageNotFound": "Сторінку не знайдено",
  "ProductSettingsCould": "Не вдалося зберегти налаштування товару.",
  "Fulfillment": "Виконання",
  "FulfillmentHelp": "Виберіть, коли товар захисту позначається як виконаний.",
  "ManuallyFulfill": "Виконати вручну",
  "MarkFulfilledWhenFir": "Позначити виконаним, коли виконано перший товар у замовленні",
  "MarkFulfilledWhenAll": "Позначити виконаним, коли виконано всі інші товари в замовленні",
  "MarkFulfilledImmedi": "Позначити виконаним одразу після створення замовлення",
  "Exclusions": "Виключення",
  "ExclusionsHelp": "Виберіть, коли захист не повинен застосовуватися.",
  "ExclusionType": "Тип виключення",
  "Select": "Вибрати",
  "SelectedExclusions": "Вибрані виключення",
  "RemoveName": "Видалити {{name}}",
  "WhenExcluded": "У разі виключення",
  "HideWidget": "Приховати віджет",
  "KeepWidgetButSkipThe": "Залишити віджет, але не стягувати плату",
  "ExcludeProductType": "Виключити тип товару",
  "SearchProductType": "Пошук типу товару",
  "ExcludeSKU": "Виключити SKU",
  "SearchSKU": "Пошук SKU",
  "ExcludeCollection": "Виключити колекцію",
  "SearchCollection": "Пошук колекції",
  "ExcludeMarket": "Виключити ринок",
  "SearchMarket": "Пошук ринку",
  "ExcludeLanguage": "Виключити мову",
  "SearchLanguage": "Пошук мови",
  "Add": "Додати",
  "PriceSettingsCouldNo": "Не вдалося зберегти налаштування ціни.",
  "ShippingProtectionPr": "Ціна захисту доставки",
  "SetHowMuchPriceDoYou": "Установіть, яку суму ви стягуєте з клієнта",
  "PricingMethod": "Метод ціноутворення",
  "Fixed": "Фіксована",
  "Percentage": "Відсоток",
  "UniversalProtectionP": "Універсальна ціна захисту",
  "PercentageOfCartSubt": "Відсоток від проміжної суми кошика",
  "EditCappedPrice": "Редагувати максимальну ціну",
  "ShippingProtectionFe": "Плата за захист доставки у відсотках від {{minPrice}} USD, зі збільшенням на {{increment}} USD, обмежена {{capped}} USD.",
  "MinProtectionFee": "Мінімальна плата за захист",
  "IncrementAmount": "Сума збільшення",
  "CappedProtectionFee": "Максимальна плата за захист",
  "AddTierPrice": "Додати ступінчасту ціну",
  "AddTier": "Додати ступінь",
  "TierPriceHelp": "Якщо ціна кошика не відповідає жодному з ваших діапазонів ступінчастих цін, застосовуватиметься універсальна ціна, установлена на попередній сторінці.",
  "MinCartPrice": "Мінімальна ціна кошика",
  "MaxCartPrice": "Максимальна ціна кошика",
  "ProtectionFee": "Плата за захист",
  "RemoveTier": "Видалити ступінь",
  "Required": "Обов’язково",
  "ThisFieldIsRequired": "Це поле обов’язкове.",
  "MustBeGreaterThanZero": "{{label}} має бути більше 0.",
  "MustBeOrLess": "{{label}} має бути {{max}} або менше.",
  "AtMostTwoDecimals": "{{label}} може мати не більше 2 знаків після коми.",
  "MustBeLargerThanMinC": "Має бути більше мінімальної ціни кошика",
  "MustBeLargerThanMaxC": "Має бути більше максимальної ціни кошика",
  "MustBeSmallerThanMin": "Має бути менше мінімальної ціни кошика",
  "Price": "Ціна",
  "MinimumPrice": "Мінімальна ціна",
  "Increment": "Збільшення",
  "CartPageWidget": "Віджет сторінки кошика",
  "CheckoutPageWidget": "Віджет сторінки оформлення замовлення",
  "WidgetFormat": "Формат віджета",
  "TickerWidget": "Стандартний віджет",
  "CheckoutButtonWidget": "Віджет кнопки оформлення замовлення",
  "Text": "Текст",
  "MainText": "Основний текст",
  "Title": "Заголовок",
  "Description": "Опис",
  "MainButtonText": "Текст основної кнопки",
  "SecondaryButtonText": "Текст додаткової кнопки",
  "EnabledDescription": "Опис увімкненого стану",
  "DisabledDescription": "Опис вимкненого стану",
  "PleaseEnterTitle": "Уведіть заголовок",
  "PleaseEnterDescript": "Уведіть опис",
  "PleaseEnterMainButt": "Уведіть текст основної кнопки",
  "PleaseEnterSecondar": "Уведіть текст додаткової кнопки",
  "PleaseEnterEnabledD": "Уведіть опис увімкненого стану",
  "PleaseEnterDisabled": "Уведіть опис вимкненого стану",
  "EGViewTerms": "наприклад, Переглянути умови",
  "EGHttpTerms": "наприклад, https://terms.com",
  "Footer": "Нижній колонтитул",
  "FooterText": "Текст нижнього колонтитула",
  "FooterLink": "Посилання в нижньому колонтитулі",
  "TooltipLink": "Посилання підказки",
  "FooterVisibility": "Видимість нижнього колонтитула",
  "TitleInfoVisibility": "Видимість інформації про заголовок",
  "Disabled": "Вимкнено",
  "Enabled": "Увімкнено",
  "Color": "Колір",
  "ColorStyle": "Стиль кольору",
  "SizeAndDisplay": "Розмір і відображення",
  "IconSize": "Розмір значка",
  "IconRadius": "Радіус значка",
  "BorderSize": "Товщина рамки",
  "BorderRadius": "Радіус рамки",
  "HorizontalPadding": "Горизонтальний відступ",
  "VerticalPadding": "Вертикальний відступ",
  "ToggleFormat": "Формат перемикача",
  "Switch": "Перемикач",
  "Checkbox": "Прапорець",
  "Border": "Рамка",
  "Background": "Фон",
  "ProtectionDescript": "Опис захисту",
  "MainButtonBackgrou": "Фон основної кнопки",
  "EnabledToggle": "Перемикач увімкнення",
  "DisabledToggle": "Перемикач вимкнення",
  "Automatic": "Автоматично",
  "Neutral": "Нейтральний",
  "Info": "Інформація",
  "Success": "Успіх",
  "Warning": "Попередження",
  "Critical": "Критичний",
  "Subdued": "Приглушений",
  "Transparent": "Прозорий",
  "ThemeColor": "Колір теми",
  "ResetToDefaultColor": "{{label}}: скинути до стандартного кольору",
  "OpenColorPicker": "{{label}}: відкрити вибір кольору",
  "Icon": "Значок",
  "PackageIcon": "Значок посилки",
  "PackageIconNumber": "Значок посилки {{value}}",
  "UploadIcon": "Завантажити значок",
  "NoIcon": "Без значка",
  "AcceptedFormats": "Доступні формати: PNG, JPG, SVG",
  "MaximumFileSize": "Максимальний розмір файлу: 50 MB",
  "AddFiles": "Додати файли",
  "RemoveImage": "Видалити зображення",
  "Uploading": "Завантаження",
  "UploadFailedTryAgain": "Не вдалося завантажити. Спробуйте ще раз.",
  "ChooseAJPEGPNG": "Виберіть зображення JPEG, PNG або SVG розміром до 50 MB.",
  "ChooseNonemptyImage": "Виберіть непорожнє зображення JPEG, JPG, PNG або SVG розміром до 50 MB.",
  "ImageCouldNotBeRead": "Не вдалося прочитати зображення.",
  "FileContentsMismatch": "Вміст файлу має відповідати типу зображення JPEG, PNG або SVG.",
  "ImageCouldNotBeDecode": "Не вдалося декодувати зображення.",
  "InvalidImageUrl": "Сервіс завантаження повернув неприпустиму URL-адресу зображення.",
  "MissingPublicImageUrl": "Сервіс завантаження не повернув публічну URL-адресу зображення.",
  "CustomCssTooLong": "Власний CSS має містити не більше 2 000 символів.",
  "ChooseValidIconUrl": "Виберіть завантажений значок із допустимою URL-адресою.",
  "EnterNumberRange": "Уведіть число від {{min}} до {{max}}.",
  "EnterLocaleTextRange": "Уведіть текст мовою {{locale}} довжиною від 1 до {{limit}} символів.",
  "EnterValidLearnMoreUrl": "Уведіть допустиму URL-адресу «Докладніше», що починається з https:// або http://.",
  "ReviewHighlightedFields": "Перевірте виділені поля.",
  "CannotChangePublishState": "Неможливо змінити стан публікації, доки форма не стане дійсною: {{reason}}",
  "BlyCareCouldNotSave": "BlyCare не вдалося зберегти.",
  "CheckoutRequiresPlus": "Налаштування оформлення замовлення потребує Shopify Plus.",
  "SaveSucceededReloadFailed": "Запит на збереження виконано, але не вдалося завантажити останні налаштування віджета. Оновіть сторінку, щоб перевірити зміни.",
  "BlyCareCouldNotComplete": "BlyCare не вдалося виконати цей запит.",
  "ShopifyAuthorizationRequired": "Потрібна авторизація Shopify.",
  "AppBridgeUnavailable": "Shopify App Bridge недоступний",
  "ExtensionStatusUnavailable": "Статус розширення Shopify недоступний.",
  "ConfigurationPreview": "Попередній перегляд конфігурації",
  "On": "Увімкнено",
  "Off": "Вимкнено",
  "Unpublish": "Зняти з публікації",
  "AppEmbedIsNotEnable": "Вбудовування застосунку не ввімкнено.",
  "GoEnabled": "Перейти до ввімкнення",
  "ViewOnYourStorefront": "Переглянути у своєму магазині",
  "PreviewProtection": "Переглянути захист",
  "MoreInformation": "Докладніше",
  "Cart": "Кошик",
  "Subtotal": "Проміжна сума",
  "Checkout": "Оформлення замовлення",
  "DiscountCode": "Код знижки",
  "Apply": "Застосувати",
  "Shipping": "Доставка",
  "Total": "Разом",
  "ShippingProtection": "Захист доставки",
  "Product": "Товар",
  "CopyLink": "Копіювати посилання"
}
